module.exports = __webpack_public_path__ + "img/licht-infrastructuur.a5682063.png";